export const palette = {
    spotifyGreen: '#1db954',
    darkBlue: 'rgb(30, 50, 65)',
    pink: '#e66465',
    purple: '#9198e5'
}
export const basePadding = 8;